import React from "react";
import { LoginForm } from "../components/login/LoginForm";
import { LoginHeader } from "../components/login/LoginHeader";

export const Login = () => {
  return (
    <div>
      <LoginHeader />
      <LoginForm />
    </div>
  );
};
